<main class="flex-1 flex flex-col mt-24 px-10 py-6">
  <section class="mb-16 flex flex-col gap-4 z-10">
    <header>
      <h1 id="home-hero-title" class="text-7xl font-bold text-lWhite leading-tight">
        Descubra <span class="text-gradient">conteúdos</span><br>
        para <span class="text-gradient">desenvolver</span> suas habilidades
      </h1>
      <p class="text-xl text-lSecondary mt-2 lg:max-w-xl">
        Explore cursos alinhados aos seus interesses, conquiste certificados e fortaleça seu perfil profissional.
      </p>
    </header>
  </section>

  <ng-template #courseCard let-course>
    <l-course-card [course]="course" />
  </ng-template>

  <section class="flex flex-col gap-6 w-full">
    <article>
      <h2 id="recommended-courses-title" class="text-3xl font-semibold text-lWhite my-10">Recomendados</h2>

      @if (isLoadingCourses) {
        <div class="flex min-h-[22rem] items-center justify-center">
          <l-spinner />
        </div>
      } @else if (courses.length) {
        <l-carousel [items]="courses" [itemTemplate]="courseCard" />
      } @else {
        <article id="recommended-courses-empty" class="text-center py-12">
          <p class="text-lSecondary text-lg">Nenhuma recomendação disponível no momento.</p>
        </article>
      }
    </article>

    <section>
      <h2 id="learn-today-title" class="text-center text-5xl font-bold text-lWhite tracking-wide mt-24 mb-10">O que você quer aprender hoje?</h2>
      <l-home-filter
        [categories]="categories"
        searchInputId="home-course-search"
        searchInputName="homeCourseSearch"
        (filtersChange)="applyFilters($event)"
      />
    </section>

    @if (isLoadingCategorySections) {
      <article class="flex min-h-[22rem] items-center justify-center">
        <l-spinner />
      </article>
    } @else {
      @for (section of categorySections; track section.categoryId) {
        <article>
          <h3 [id]="'category-title-' + section.categoryId" class="mt-10 mb-8 text-3xl font-semibold text-lWhite">{{ section.categoryName }}</h3>
          <l-carousel [items]="section.courses || []" [itemTemplate]="courseCard" />
        </article>
      }
    }
  </section>
</main>
